import { Tabs, theme } from "antd";
import React from 'react';
import { openPopup2, POPUP_TYPE } from "../../../../contexts/PopupContext";
import { SiteDetailProvider } from "../../../../contexts/SiteDetailContext";
import { datetime } from "../../../../util/library/datetime";
import { zIndex } from "../../../../util/varibles/constants";
import { ISite } from "../../../../util/varibles/interface";
import Chart from "./Chart";
import Units from "./Chart/Units";
import Info from "./Info";
import styles from "./style.module.scss";

export enum TabSiteId {
    Info = 'info',
    Analytics = 'analytics',
}

export interface IProps {
    data: { id: string, name: string }
    unitId?: string
    year?: number
    tab?: TabSiteId

    onUpdate?(value: ISite): void
}

const SiteDetail: React.FC<IProps> = ({ data, unitId, tab = TabSiteId.Analytics, year = datetime().year, onUpdate }) => {
    const { token: { colorBgContainer } } = theme.useToken();

    return <SiteDetailProvider data={data} unitId={unitId} year={`${year}`} onUpdate={onUpdate}>
        <div className={styles.content}>
            <Tabs
                defaultActiveKey={tab}
                renderTabBar={(props, DefaultTabBar) => (
                    <div className={styles.tabs}>
                        <DefaultTabBar {...props} style={{ background: colorBgContainer }} />
                    </div>
                )}
                items={[
                    {
                        key: TabSiteId.Info,
                        label: 'Site info',
                        children: <Info />
                    },
                    {
                        key: TabSiteId.Analytics,
                        label: 'Analytics',
                        children: <>
                            <Units />
                            <Chart />
                        </>
                    }
                ]}
            />
        </div>
    </SiteDetailProvider>;
};

export const openSitePopup = (data: { id: string, name: string }) => openPopup2(<SiteDetail data={data} tab={TabSiteId.Info} />, {
    modalProps: {
        title: data.name,
        width: '100%',
        zIndex: zIndex.popupLev1
    },
    popupType: POPUP_TYPE.DRAWER
});

export default SiteDetail;
